module.exports = __webpack_public_path__ + "img/Mosslord-battle-Kiki-Moch-Rizky.8185a4a5.jpg";